import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-beta-message',
  templateUrl: './beta-message.component.html',
  styleUrls: ['./beta-message.component.scss']
})
export class BetaMessageComponent implements OnInit {

  @Input() extra : string = "";

  constructor() { }

  ngOnInit() {
    
  }

}
